import PropTypes from "prop-types"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"

const GenerateInvoiceDetailsStep = ({ contact }) => {
  const { control } = useFormContext()

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <Form.Label htmlFor="dueDate">Due date</Form.Label>
        <Controller
          name="dueDate"
          control={control}
          render={({ field }) => (
            <Form.DatePicker
              id="dueDate"
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>

      <div className="rounded-lg border bg-gray-100 p-4 text-sm text-gray-700">
        <span className="font-semibold">Payment:</span> Manual collection
        <p className="mt-1 text-gray-500">
          Per-invoice AutoPay is coming soon; this invoice will be collected
          manually.
        </p>
      </div>

      <Controller
        name="sendEmail"
        control={control}
        render={({ field }) => (
          <Form.Checkbox
            name="sendEmail"
            checked={!!field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            labelClassName="m-0 ml-2"
          >
            <div className="flex flex-col">
              <span className="text-gray-900">
                Email invoice to {contact?.name}
              </span>
              {contact?.email ? (
                <span className="text-sm text-gray-500">{contact.email}</span>
              ) : (
                <span className="text-sm text-gray-400">No email on file</span>
              )}
            </div>
          </Form.Checkbox>
        )}
      />
    </div>
  )
}

GenerateInvoiceDetailsStep.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
}

export default GenerateInvoiceDetailsStep
